import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { UNLOAD_EXAMPLE } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { UnloadExampleDataActionTypes } from './types';
import api from 'src/utils/api';

export const unloadExample =
  (): ThunkAction<Promise<void>, State, null, UnloadExampleDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: UNLOAD_EXAMPLE + REQUEST });
    try {
      await api.unloadExample();
      dispatch({ type: UNLOAD_EXAMPLE + SUCCESS });
    } catch (error) {
      dispatch({ type: UNLOAD_EXAMPLE + FAILURE, error });
    }
  };

export const unloadExampleIdle = () => ({ type: UNLOAD_EXAMPLE + IDLE });
